<template>
    <div class="page-title-area bg-21">
        <div class="container">
            <div class="page-title-content">
                <h2>Our Project</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Project</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>